(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["layouts"] = factory();
	else
		root["layouts"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Cached window identity (@see getId)
 */
let id;
/**
 * The identity of the main application window of the service provider
 */
exports.SERVICE_IDENTITY = {
    uuid: 'layouts-service',
    name: 'layouts-service'
};
/**
 * Name of the IAB channel use to communicate between client and provider
 */
exports.SERVICE_CHANNEL = 'of-layouts-service-v1';
/**
 * Returns the identity of the window that is calling these functions
 */
function getId() {
    if (!id) {
        id = parseIdentity(fin.Window.me);
    }
    return id;
}
exports.getId = getId;
/**
 * Returns an Identity from a complete window object.  Useful to remove only the Identity instead of sending through a whole window context.
 *
 * Assumed that the supplied object has uuid & name.
 */
function parseIdentity(identity) {
    if (identity === null || typeof identity !== 'object') {
        throw new Error("Invalid arguments. Must pass an identity object" /* IDENTITY_REQUIRED */);
    }
    const uuidCheck = typeof identity.uuid === 'string';
    const nameCheck = !identity.name || typeof identity.name === 'string';
    if (!uuidCheck && !nameCheck) {
        throw new Error("Invalid Identity provided: uuid and name must be strings" /* INVALID_IDENTITY_BOTH */);
    }
    else if (!uuidCheck) {
        throw new Error("Invalid Identity provided: uuid must be a string" /* INVALID_IDENTITY_UUID */);
    }
    else if (!nameCheck) {
        throw new Error("Invalid Identity provided: name must be a string or undefined" /* INVALID_IDENTITY_NAME */);
    }
    return { uuid: identity.uuid, name: identity.name || identity.uuid };
}
exports.parseIdentity = parseIdentity;
/**
 * Like parseIdentity above, but also allows properties to be regex objects.
 */
function parseIdentityRule(identity) {
    if (identity === null || typeof identity !== 'object') {
        throw new Error("Invalid arguments. Must pass an identity object" /* IDENTITY_REQUIRED */);
    }
    const uuidCheck = typeof identity.uuid === 'string' || isRegex(identity.uuid);
    const nameCheck = !identity.name || typeof identity.name === 'string' || isRegex(identity.name);
    if (!uuidCheck && !nameCheck) {
        throw new Error("Invalid Identity provided: uuid and name must be strings or RegEx objects" /* INVALID_IDENTITYRULE_BOTH */);
    }
    else if (!uuidCheck) {
        throw new Error("Invalid Identity provided: uuid must be a string or RegEx object" /* INVALID_IDENTITYRULE_UUID */);
    }
    else if (!nameCheck) {
        throw new Error("Invalid Identity provided: name must be a string, RegEx object, or undefined" /* INVALID_IDENTITYRULE_NAME */);
    }
    return { uuid: identity.uuid, name: identity.name || identity.uuid };
}
exports.parseIdentityRule = parseIdentityRule;
// tslint:disable-next-line:no-any This is a type guard, and so can take any object.
function isRegex(a) {
    return !!a.expression && typeof a.expression === 'string' && (a.flags === undefined || typeof a.flags === 'string') &&
        (a.invert === undefined || typeof a.invert === 'boolean');
}
var TabAPI;
(function (TabAPI) {
    TabAPI["CREATETABGROUP"] = "CREATETABGROUP";
    TabAPI["SETTABSTRIP"] = "SETTABSTRIP";
    TabAPI["GETTABS"] = "GETTABS";
    TabAPI["TAB_WINDOW_TO_WINDOW"] = "TAB_WINDOW_TO_WINDOW";
    TabAPI["REMOVETAB"] = "REMOVETAB";
    TabAPI["SETACTIVETAB"] = "SETACTIVETAB";
    TabAPI["MINIMIZETABGROUP"] = "MINIMIZETABGROUP";
    TabAPI["MAXIMIZETABGROUP"] = "MAXIMIZETABGROUP";
    TabAPI["CLOSETABGROUP"] = "CLOSETABGROUP";
    TabAPI["RESTORETABGROUP"] = "RESTORETABGROUP";
    TabAPI["REORDERTABS"] = "REORDERTABS";
    TabAPI["STARTDRAG"] = "STARTDRAG";
    TabAPI["ENDDRAG"] = "ENDDRAG";
    TabAPI["UPDATETABPROPERTIES"] = "UPDATETABPROPERTIES";
    TabAPI["CLOSETAB"] = "CLOSETAB";
})(TabAPI = exports.TabAPI || (exports.TabAPI = {}));
var WorkspaceAPI;
(function (WorkspaceAPI) {
    WorkspaceAPI["RESTORE_HANDLER"] = "SET-RESTORE-HANDLER";
    WorkspaceAPI["GENERATE_HANDLER"] = "SET-GENERATE-HANDLER";
    WorkspaceAPI["GENERATE_LAYOUT"] = "GENERATE-WORKSPACE";
    WorkspaceAPI["RESTORE_LAYOUT"] = "RESTORE-WORKSPACE";
    WorkspaceAPI["APPLICATION_READY"] = "WORKSPACE-APP-READY";
})(WorkspaceAPI = exports.WorkspaceAPI || (exports.WorkspaceAPI = {}));
var SnapAndDockAPI;
(function (SnapAndDockAPI) {
    SnapAndDockAPI["UNDOCK_WINDOW"] = "UNDOCK-WINDOW";
    SnapAndDockAPI["UNDOCK_GROUP"] = "UNDOCK-GROUP";
    SnapAndDockAPI["GET_DOCKED_WINDOWS"] = "GET-DOCKED-WINDOWS";
})(SnapAndDockAPI = exports.SnapAndDockAPI || (exports.SnapAndDockAPI = {}));
var RegisterAPI;
(function (RegisterAPI) {
    RegisterAPI["REGISTER"] = "REGISTER";
    RegisterAPI["DEREGISTER"] = "DEREGISTER";
})(RegisterAPI = exports.RegisterAPI || (exports.RegisterAPI = {}));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * File contains vars used to establish service connection between client and provider.
 *
 * These are separated out from 'internal.ts' as including these from provider code will cause the provider to connect
 * to itself.
 *
 * These types are a part of the client, but are not required by applications wishing to interact with the service.
 * This file is excluded from the public-facing TypeScript documentation.
 */
const events_1 = __webpack_require__(3);
const internal_1 = __webpack_require__(0);
/**
 * The event emitter to emit events received from the service.  All addEventListeners will tap into this.
 */
exports.eventEmitter = new events_1.EventEmitter();
/**
 * Promise to the channel object that allows us to connect to the client
 */
let channelPromise = null;
if (typeof fin !== 'undefined') {
    getServicePromise();
}
function getServicePromise() {
    if (!channelPromise) {
        channelPromise = typeof fin === 'undefined' ?
            Promise.reject(new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.')) :
            fin.InterApplicationBus.Channel.connect(internal_1.SERVICE_CHANNEL, { payload: { version: '1.1.0' } }).then((channel) => {
                // Register service listeners
                channel.register('WARN', (payload) => console.warn(payload)); // tslint:disable-line:no-any
                channel.register('event', (event) => {
                    exports.eventEmitter.emit(event.type, event);
                });
                // Any unregistered action will simply return false
                channel.setDefaultAction(() => false);
                return channel;
            });
    }
    return channelPromise;
}
exports.getServicePromise = getServicePromise;
/**
 * Wrapper around service.dispatch to help with type checking
 */
async function tryServiceDispatch(action, payload) {
    const channel = await getServicePromise();
    return channel.dispatch(action, payload);
}
exports.tryServiceDispatch = tryServiceDispatch;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Index
 */
const connection_1 = __webpack_require__(1);
const internal_1 = __webpack_require__(0);
const snapAndDock = __importStar(__webpack_require__(4));
exports.snapAndDock = snapAndDock;
const tabbing = __importStar(__webpack_require__(5));
exports.tabbing = tabbing;
const tabstrip = __importStar(__webpack_require__(6));
exports.tabstrip = tabstrip;
const workspaces = __importStar(__webpack_require__(7));
exports.workspaces = workspaces;
const restoreHelpers = __importStar(__webpack_require__(8));
exports.restoreHelpers = restoreHelpers;
/**
 * Allows a window to opt-out of this service.
 *
 * This will disable *all* layouts-related functionality for the given window.
 *
 * Multiple windows can be deregistered at once by using regex patterns on `identity.uuid`/`identity.name`.
 *
 * This API can be used to programmatically override configuration set at an app-wide level, such as in the application manifest.
 *
 * ```ts
 * import {deregister} from 'openfin-layouts';
 *
 * // De-register the current window
 * deregister();
 *
 * // De-register a single named window
 * deregister({uuid: 'my-uuid', name: 'window'});
 *
 * // De-register multiple windows belonging to the same application
 * deregister({uuid: 'my-uuid', name: {expression: 'popup-.*'}});
 *
 * // De-register all windows belonging to an application, not matching a pattern
 * deregister({uuid: 'my-uuid', name: {expression: 'interactive-.*', invert: true}});
 * ```
 *
 * @param identity The window (or pattern of windows) to deregister, defaults to the current window
 */
async function deregister(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.RegisterAPI.DEREGISTER, internal_1.parseIdentityRule(identity));
}
exports.deregister = deregister;
/**
 * Allows a window to opt-in back to this service if previously deregistered.
 *
 * This will enable *all* layouts-related functionality for the given window unless alternative behaviors are set in the layout configuration.
 *
 * This API can be used to programmatically override configuration set at an app-wide level, such as in the application manifest.
 *
 * This API is provided to complement {@link deregister}, to allow programmatic override of default service behavior or configuration
 * specified in an application manifest. This API is not required or intended for initial opt-in of your application to the service,
 * which is achieved through the `"services"` attribute within an application manifest.
 *
 * ```ts
 * import {register} from 'openfin-layouts';
 *
 * // Register the current window
 * register();
 *
 * // Register a single named window
 * register({uuid: 'my-uuid', name: 'window'});
 *
 * // Register multiple windows belonging to the same application
 * register({uuid: 'my-uuid', name: {expression: 'interactive-.*'}});
 *
 * // Register all windows belonging to an application, not matching a pattern
 * register({uuid: 'my-uuid', name: {expression: 'popup-.*', invert: true}});
 * ```
 *
 * @param identity The window (or pattern of windows) to register, defaults to the current window
 */
async function register(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.RegisterAPI.REGISTER, internal_1.parseIdentityRule(identity));
}
exports.register = register;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const connection_1 = __webpack_require__(1);
const internal_1 = __webpack_require__(0);
function addEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.addListener(eventType, listener);
}
exports.addEventListener = addEventListener;
function removeEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.removeListener(eventType, listener);
}
exports.removeEventListener = removeEventListener;
/**
 * Undocks a window from any group it currently belongs to.
 *
 * Has no effect if the window is not currently docked.
 *
 * ```ts
 * import {snapAndDock} from 'openfin-layouts';
 *
 * // Undock the current window (all are equivalent)
 * snapAndDock.undockWindow();
 * snapAndDock.undockWindow(fin.desktop.Window.getCurrent());   // Using 'v1' API
 * snapAndDock.undockWindow(fin.Window.getCurrentSync());       // Using 'v2' API
 *
 * // Undock a different window
 * snapAndDock.undockWindow({uuid: 'my-app', name: 'other-window'});
 * ```
 *
 * @param identity The window to undock, defaults to the current window
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If the window specified by `identity` does not exist
 * @throws `Error`: If the window specified by `identity` has been de-registered
 */
async function undockWindow(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.SnapAndDockAPI.UNDOCK_WINDOW, internal_1.parseIdentity(identity));
}
exports.undockWindow = undockWindow;
/**
 * Will undock every window that is currently connected to a current window.
 *
 * This will completely disband the entire group, not just the windows directly touching `identity`.
 *
 * Has no effect if `identity` isn't currently snapped to any other window.
 *
 * ```ts
 * import {snapAndDock} from 'openfin-layouts';
 *
 * // Undock all windows attached to the current window (all are equivalent)
 * snapAndDock.undockGroup();
 * snapAndDock.undockGroup(fin.desktop.Window.getCurrent());   // Using 'v1' API
 * snapAndDock.undockGroup(fin.Window.getCurrentSync());       // Using 'v2' API
 *
 * // Undock all windows attached to a different window
 * snapAndDock.undockGroup({uuid: 'my-app', name: 'other-window'});
 * ```
 *
 * @param identity A window belonging to the group that should be disbanded, defaults to the current window/group
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If the window specified by `identity` does not exist
 * @throws `Error`: If the window specified by `identity` has been de-registered
 */
async function undockGroup(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.SnapAndDockAPI.UNDOCK_GROUP, internal_1.parseIdentity(identity));
}
exports.undockGroup = undockGroup;
/**
 * Returns an array representing the entities docked with the provided window (see {@link DockGroup} for more details).
 *
 * If the window is not docked returns null.
 *
 * ```ts
 * import {snapAndDock} from 'openfin-layouts';
 *
 * // Gets all tabs for the current window context.
 * const myGroup: DockGroup | null = snapAndDock.getDockedWindows();
 *
 * // Get all tabs for another window context.
 * const otherWindow: Identity = {uuid: "sample-window-uuid", name: "sample-window-name"}
 * const otherWindowGroup: DockGroup | null = snapAndDock.getDockedWindows(otherWindow);
 * ```
 *
 * @param identity The window context, defaults to the current window.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If the window specified by `identity` does not exist
 * @throws `Error`: If the window specified by `identity` has been de-registered
 * @throws `Error`: If the provider is running an incompatible version
 *
 * @since 1.0.3
 */
async function getDockedWindows(identity = internal_1.getId()) {
    const response = await connection_1.tryServiceDispatch(internal_1.SnapAndDockAPI.GET_DOCKED_WINDOWS, internal_1.parseIdentity(identity));
    // @ts-ignore Compatability check. Provider will return false on unregistered actions.
    if (response === false) {
        console.warn('Warning: The currently running layouts service does not support the "getDockedWindows" method.');
        return null;
    }
    return response;
}
exports.getDockedWindows = getDockedWindows;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const connection_1 = __webpack_require__(1);
const internal_1 = __webpack_require__(0);
function addEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.addListener(eventType, listener);
}
exports.addEventListener = addEventListener;
function removeEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.removeListener(eventType, listener);
}
exports.removeEventListener = removeEventListener;
/**
 * Returns array of window identity references for tabs belonging to the tab group of the provided window context.
 *
 * If there is no tab group associated with the window context, will resolve to null.
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Gets all tabs for the current window context.
 * tabbing.getTabs();
 *
 * // Get all tabs for another window context.
 * tabbing.getTabs({uuid: "sample-window-uuid", name: "sample-window-name"});
 * ```
 *
 * @param identity The window context, defaults to the current window.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 */
async function getTabs(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.GETTABS, { name: identity.name, uuid: identity.uuid });
}
exports.getTabs = getTabs;
/**
 * Creates the custom tabstrip + configuration for the entire application.  An application cannot have different windows using different tabstrip UIs.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * tabbing.setTabstrip({url: 'https://localhost/customTabstrip.html', height: 60});
 * ```
 *
 * @param config The {@link ApplicationUIConfig| Application UI Configuration} object.
 * @throws `Error`: If `config` is not a valid {@link ApplicationUIConfig}
 * @throws `Error`: If `config.url` is not a valid URL/URI.
 */
async function setTabstrip(config) {
    if (!config || isNaN(config.height) || !config.url.length) {
        return Promise.reject(new Error('Invalid config provided'));
    }
    try {
        // tslint:disable-next-line:no-unused-expression We're only checking a valid URL was provided.  No need to assign the resulting object.
        new URL(config.url);
    }
    catch (e) {
        return Promise.reject(e);
    }
    return connection_1.tryServiceDispatch(internal_1.TabAPI.SETTABSTRIP, { id: internal_1.getId(), config });
}
exports.setTabstrip = setTabstrip;
/**
 * Creates a tabgroup with the provided windows.  The first window in the set will be used to define the tab strips properties.  See {@link setTabstrip}.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * tabbing.createTabGroup([{uuid: "App1", name: "App1"}, {uuid: "App2", name: "App2"}, {uuid: "App3", name: "App3"}]);
 * ```
 *
 * @param identities Array of window {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identities} which will be added to the
 * new tab group.
 * @param activeTab The {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity} of the window to set as the active tab in
 * the group.  If not provided, the first tab in the tab group will be set as the active tab.
 * @throws `Error`: If one of the provided {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identities} is not valid.
 * @throws `Error`: If duplicate {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identities} are provided.
 * @throws `Error`: If the provided value is not an array or less than 2 windows identities were provided.
 */
async function createTabGroup(identities, activeTab) {
    const onlyIdentities = identities.map(id => internal_1.parseIdentity(id));
    const active = activeTab && internal_1.parseIdentity(activeTab) || undefined;
    return connection_1.tryServiceDispatch(internal_1.TabAPI.CREATETABGROUP, { windows: onlyIdentities, activeTab: active });
}
exports.createTabGroup = createTabGroup;
/**
 * Tabs two windows together.  If the targetWindow is already in a group, the tab will be added to that group.
 *
 * The added tab will be brought into focus.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Tab App1 to App2
 * tabbing.tabWindowToWindow({uuid: 'App1', name: 'App1'}, {uuid: 'App2', name: 'App2'});
 * ```
 *
 * @param windowToAdd The identity of the window to add to the tab group.
 * @param targetWindow The identity of the window to create a tab group on.
 * @throws `Error`: If the {@link ApplicationUIConfig| App Config} does not match between the target and window to add.
 * @throws `Error`: If the `targetWindow` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If the `windowToAdd` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 */
async function tabWindowToWindow(windowToAdd, targetWindow) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.TAB_WINDOW_TO_WINDOW, {
        targetWindow: internal_1.parseIdentity(targetWindow),
        windowToAdd: internal_1.parseIdentity(windowToAdd)
    });
}
exports.tabWindowToWindow = tabWindowToWindow;
/**
 * Removes the specified window context from its tab group.  This does not close the window.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Remove the window from its tab group.
 * tabbing.removeTab();
 *
 * // Remove another window from its tab group.
 * tabbing.removeTab({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param identity Identity of the window context to remove.  If no `Identity` is provided as an argument, the current window context will be used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` refers to a window that doesn't exist, or is deregistered from the service.
 */
async function removeTab(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.REMOVETAB, internal_1.parseIdentity(identity));
}
exports.removeTab = removeTab;
/**
 * Sets the window context as the active tab in its tab group.  Active tabs are brought to the front of the tab group and shown.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts'
 *
 * // Sets the current window as active in the tab group.
 * tabbing.setActiveTab()
 *
 * // Sets another window context as the active tab.
 * tabbing.setActiveTab({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param identity Identity of the window context to set as active.  If no `Identity` is provided as an argument the current window context will be used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` is not an existing tab in a tabstrip.
 */
async function setActiveTab(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.SETACTIVETAB, internal_1.parseIdentity(identity));
}
exports.setActiveTab = setActiveTab;
/**
 * Closes the tab for the window context and removes it from its associated tab group.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Closes the current window context tab.
 * tabbing.closeTab();
 *
 * // Closes another windows context tab.
 * tabbing.closeTab({uuid: 'App1', name: 'App1'});
 * ```
 *
 * Note that the `identity` doesn't need to be tabbed for this call to take effect - so long as the window is known with the service.
 *
 * @param identity Identity of the window context to close.  If no `Identity` is provided as an argument the current window context will be used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` refers to a window that doesn't exist, or is deregistered from the service.
 */
async function closeTab(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.CLOSETAB, internal_1.parseIdentity(identity));
}
exports.closeTab = closeTab;
/**
 * Minimizes the tab group for the window context.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Minimizes the tab group for the current window context.
 * tabbing.minimizeTabGroup();
 *
 * // Minimizes the tab group for another windows context.
 * tabbing.minimizeTabGroup({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param identity Identity of the window context to minimize the tab group for.  If no `Identity` is provided as an argument the current window context will be
 * used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` is not an existing tab in a tabstrip.
 */
async function minimizeTabGroup(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.MINIMIZETABGROUP, internal_1.parseIdentity(identity));
}
exports.minimizeTabGroup = minimizeTabGroup;
/**
 * Maximizes the tab group for the window context.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Maximizes the tab group for the current window context.
 * tabbing.maxmimizeTabGroup();
 *
 * // Maximizes the tab group for another windows context.
 * tabbing.maximizeTabGroup({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param identity Identity of the window context to maximize the tab group for.  If no `Identity` is provided as an argument the current window context will be
 * used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` is not an existing tab in a tabstrip.
 */
async function maximizeTabGroup(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.MAXIMIZETABGROUP, internal_1.parseIdentity(identity));
}
exports.maximizeTabGroup = maximizeTabGroup;
/**
 * Restores the tab group for the window context to its normal state.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Restores the tab group for the current window context.
 * tabbing.restoreTabGroup();
 *
 * // Restores the tab group for another windows context.
 * tabbing.restoreTabGroup({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param identity Identity of the window context to restore the tab group for.  If no `Identity` is provided as an argument the current window context will be
 * used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` is not an existing tab in a tabstrip.
 */
async function restoreTabGroup(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.RESTORETABGROUP, internal_1.parseIdentity(identity));
}
exports.restoreTabGroup = restoreTabGroup;
/**
 * Closes the tab group for the window context.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Closes the tab group for the current window context.
 * tabbing.closeTabGroup();
 *
 * // Closes the tab group for another windows context.
 * tabbing.closeTabGroup({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param identity Identity of the window context to close the tab group for.  If no `Identity` is provided as an argument the current window context will be
 * used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If `identity` is not an existing tab in a tabstrip.
 */
async function closeTabGroup(identity = internal_1.getId()) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.CLOSETABGROUP, internal_1.parseIdentity(identity));
}
exports.closeTabGroup = closeTabGroup;
/**
 * Updates a tab's properties. Properties for a tab include its title and icon when in a tab group.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Updating only some properties for the current window context.
 * tabbing.updateTabProperties({title: 'An Awesome Tab!'});
 *
 * // Update all properties for the current window context.
 * tabbing.updateTabProperties({title: 'An Awesome Tab!', icon: 'http://openfin.co/favicon.ico'});
 *
 * // Update properties for another windows context.
 * tabbing.updateTabProperties({title: 'An Awesome Tab'}, {uuid: 'App1', name: 'App1'});
 * ```
 * @param properties Properties object for the tab to consume.
 * @param identity Identity of the window context set the properties on.  If no `Identity` is provided as an argument the current window context will be used.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 */
async function updateTabProperties(properties, identity = internal_1.getId()) {
    if (!properties) {
        throw new Error("Properties are required" /* PROPERTIES_REQUIRED */);
    }
    return connection_1.tryServiceDispatch(internal_1.TabAPI.UPDATETABPROPERTIES, { window: internal_1.parseIdentity(identity), properties });
}
exports.updateTabProperties = updateTabProperties;
/**
 * Adds the provided window context as a tab to the current window context.
 *
 * The added tab will be brought into focus.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Tab App2 to current window.
 * tabbing.tabToSelf({uuid: 'App2', name: 'App2'});
 * ```
 *
 * @param Identity The identity of the window to add as a tab.
 * @throws `Error`: If the {@link ApplicationUIConfig| App Config} does not match between the window to add and the current window context.
 * @throws `Error`: If the `Identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If the `Identity` matches the calling windows `Identity`.
 */
async function tabToSelf(identity) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.TAB_WINDOW_TO_WINDOW, { targetWindow: internal_1.getId(), windowToAdd: internal_1.parseIdentity(identity) });
}
exports.tabToSelf = tabToSelf;
/**
 * Adds the current window context as a tab to the provided window context.
 *
 * The added tab will be brought into focus.
 *
 * ```ts
 * import {tabbing} from 'openfin-layouts';
 *
 * // Tab current window to App1.
 * tabbing.tabSelfTo({uuid: 'App1', name: 'App1'});
 * ```
 *
 * @param Identity The identity of the window to add the current window context as a tab to.
 * @throws `Error`: If the {@link ApplicationUIConfig| App Config} does not match between the window to add and the current window context.
 * @throws `Error`: If the `Identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 * @throws `Error`: If the `Identity` matches the calling windows `Identity`.
 */
async function tabSelfTo(identity) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.TAB_WINDOW_TO_WINDOW, { targetWindow: internal_1.parseIdentity(identity), windowToAdd: internal_1.getId() });
}
exports.tabSelfTo = tabSelfTo;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const connection_1 = __webpack_require__(1);
const internal_1 = __webpack_require__(0);
function addEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.addListener(eventType, listener);
}
exports.addEventListener = addEventListener;
function removeEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.removeListener(eventType, listener);
}
exports.removeEventListener = removeEventListener;
/**
 * Informs the layouts service a tab HTML5 drag sequence has begun.  Required at the beginning of any tabstrip drag operation.
 * Only one dragging operation should ever be taking place.
 *
 * ```ts
 * import {tabstrip} from 'openfin-layouts';
 *
 * window.document.body.addEventListener("dragstart", (event) => {
 *      tabstrip.startDrag({uuid: 'App0', name: 'App0'});
 * });
 * ```
 *
 * @param identity The identity of the tab which is being dragged.
 * @throws `Error`: If `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 */
async function startDrag(identity) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.STARTDRAG, internal_1.parseIdentity(identity));
}
exports.startDrag = startDrag;
/**
 * Informs the layouts service a tab HTML5 drag sequence has ended.  Required at the end of any tabstrip drag operation.
 * Only one dragging operation should ever be taking place.
 *
 * ```ts
 * import {tabstrip} from 'openfin-layouts';
 *
 * window.document.body.addEventListener("dragend", (event) => {
 *      tabstrip.endDrag();
 * })
 * ```
 */
async function endDrag() {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.ENDDRAG);
}
exports.endDrag = endDrag;
/**
 * Updates the layouts service provider with the new order of tabs in a tabstrip.  Required for workspace restore operations to restore the tabs in the correct
 * order.
 *
 * This call is purely informational and will not trigger any events.
 *
 * The length of the provided array must match the current number of tabs, and each current tab must appear in the array exactly once to be valid.
 *
 * ```ts
 * import {tabstrip} from 'openfin-layouts';
 *
 * const tabs = [{uuid: 'App0', name: 'App0'}, {uuid: 'App1', name: 'App1'}, {uuid: 'App2', name: 'App2'}];
 *
 * tabstrip.reorderTabs(tabs);
 * ```
 *
 * @param newOrder The new order of the tabs.  First index in the array will match the first tab in the strip.
 * @throws `Error`: If the provided value is not an array.
 * @throws `Error`: If array item type `identity` is not a valid {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity |
 * Identity}.
 * @throws `Error`: If not all tabs present in the tabstrip are in the provided array.
 * @throws `Error`: If array item is not in the calling tab group.
 */
async function reorderTabs(newOrder) {
    return connection_1.tryServiceDispatch(internal_1.TabAPI.REORDERTABS, newOrder.map(identity => internal_1.parseIdentity(identity)));
}
exports.reorderTabs = reorderTabs;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const connection_1 = __webpack_require__(1);
const internal_1 = __webpack_require__(0);
function addEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.addListener(eventType, listener);
}
exports.addEventListener = addEventListener;
function removeEventListener(eventType, listener) {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-layouts module is only intended for use in an OpenFin application.');
    }
    connection_1.eventEmitter.removeListener(eventType, listener);
}
exports.removeEventListener = removeEventListener;
/**
 * Register a callback that will save the state of the calling application.
 *
 * The callback will be invoked on each call to {@link generate}, and the return value (if anything is returned)
 * will be saved as the workspace's `customData` property for this app within the generated {@link Workspace}.
 *
 * ``` ts
 * import {workspaces} from 'openfin-layouts';
 *
 * workspaces.setGenerateHandler(() => {
 *     // Return custom data
 *     return {currentStockSymbol: this._currentStockSymbol};
 * });
 * ```
 *
 */
async function setGenerateHandler(customDataDecorator) {
    const channel = await connection_1.getServicePromise();
    return channel.register(internal_1.WorkspaceAPI.GENERATE_HANDLER, customDataDecorator);
}
exports.setGenerateHandler = setGenerateHandler;
/**
 * Registers a callback that will restore the application to a previous state.
 *
 * If an application has set a {@link setRestoreHandler} callback, and called the {@link ready} function, the layouts service
 * will send it its Workspace data when the {@link restore} function is called, and wait for this function to return. If
 * an application has saved its child windows, it *MUST* create those child windows with the same names defined in its
 * Workspace. If those child windows are already up, position them in their proper location using the bounds given.
 *
 * If this function does not return, or this function does not create the app's child windows appropriately,
 * {@link restore} will hang indefinitely.
 *
 * If the callback does not return a WorkspaceApp object, window grouping will be affected. The {@link restore} function reads
 * the return value and uses it to continue restoration.
 *
 * It is recommended that you restore/position the child windows defined in workspaceApp, and after those windows have been created, return
 * that same workspaceApp object.
 *
 * ``` ts
 * import {workspaces} from 'openfin-layouts';
 * import {WorkspaceApp, WorkspaceWindow} from 'openfin-layouts/dist/client/workspaces';
 *
 * async function appRestoreHandler(workspaceApp: Workspace) {
 *     const ofApp = await fin.Application.getCurrent();
 *     const openWindows = await ofApp.getChildWindows();
 *     // Iterate through the child windows of the workspaceApp data
 *     const opened = workspaceApp.childWindows.map(async (childWinInfo: WorkspaceWindow, index: number) => {
 *         // Check for existence of the window
 *         let openChildWin = openWindows.find(w => w.identity.name === childWinInfo.name);
 *         if (!openChildWin) {
 *             openChildWin = await openChild(childWinInfo.name, childWinInfo.url);
 *         }
 *         // Create the OpenFin window with the same name
 *         // Position the window based on the data in the workspaceApp
 *         // The user provides this positioning function
 *         await positionWindow(childWinInfo, openChildWin);
 *     });
 *
 *     // Wait for all windows to open and be positioned before returning
 *     await Promise.all(opened);
 *     return layoutApp;
 * }
 *
 * workspaces.setRestoreHandler(appRestoreHandler);
 * ```
 */
async function setRestoreHandler(listener) {
    const channel = await connection_1.getServicePromise();
    return channel.register(internal_1.WorkspaceAPI.RESTORE_HANDLER, listener);
}
exports.setRestoreHandler = setRestoreHandler;
/**
 * Generates a JSON Workspace object that contains the state of the current desktop.
 *
 * The returned JSON will contain information for the main window of every application that is currently open and hasn't
 * explicitly de-registered itself from the service. It will also contain positioning, tabbing and grouping information
 * for each application. This data will be passed to {@link restore}, which will create the applications and
 * position them appropriately.
 *
 * If an application wishes to restore its child windows and store custom data, it must properly integrate with the
 * layouts service by both registering {@link setGenerateHandler|generate} and {@link setRestoreHandler|restore} callbacks, and
 * calling the {@link ready} function. If this is not done properly, workspace restoration may be disrupted.
 *
 * ``` ts
 * import {workspaces} from 'openfin-layouts';
 * import {Workspace} from 'openfin-layouts/dist/client/workspaces';
 *
 * async function saveCurrentWorkspace() {
 *    const workspaceObject: Workspace = await workspaces.generate();
 *    // Persist the workspaceObject in a location of your choosing
 *    saveWorkspace(workspaceObject);
 *    return workspaceObject;
 * }
 * ```
 *
 */
async function generate() {
    return connection_1.tryServiceDispatch(internal_1.WorkspaceAPI.GENERATE_LAYOUT);
}
exports.generate = generate;
/**
 * Takes a Workspace object created by the {@link generate} function and restores the state of the desktop at the time it was generated
 *
 * Restoration begins by reading the Workspace object, and determining what applications and windows are running or not.
 *
 * If an application or child window is not up and running, the layouts service will create a transparent placeholder window for it, as an
 * indication to the user that a window is in the process of loading. The placeholder window will listen for its corresponding window to
 * come up, and subsequently close itself.
 *
 * Once all placeholder windows are up, the layouts service will ungroup and un-tab any windows participating in restoration. This is done to
 * prevent a window from dragging its group around the desktop, into a location that wasn't originally intended. Restore does not touch
 * any windows that were not declared in the Workspace object.
 *
 * Once all windows are ungrouped, the layouts service will then tab together all windows involved in a tabgroup. Placeholder windows are
 * included in this tabbing step. Once a placeholder window's corresponding restored window comes up, that restored window takes
 * the place of the placeholder window in the tabset.
 *
 * Once all groups have been set up, the layouts service will then begin opening and positioning the applications and windows.
 *
 * If an application is up and running, the layouts service will position it in its proper place. If the application isn't running,
 * the layouts service will attempt to launch it after it has been launched. It is then positioned.
 *
 * If the application has registered {@link setGenerateHandler|generate} and {@link setRestoreHandler|restore} callbacks, and called
 * the {@link ready} function, the layouts service will send it its Workspace data. If an application has saved its child windows,
 * it *MUST* create those child windows with the same names defined in its Workspace. If it does not do so, {@link restore} will fail.
 *
 * Once all applications and child windows have been spun up and positioned, and all placeholder windows have been closed, the layouts
 * service will then group all windows that were formerly snapped together.
 *
 * Finally, the layouts service will send a 'workspace-restored' event to all windows, and complete restoration.
 *
 * ``` ts
 * import {workspaces} from 'openfin-layouts';
 *
 * workspaces.restore(workspaceObject).then(result => {
 *    // Promise resolves with result once the layout has been restored
 *    handleResult(result);
 * });
 * ```
 *
 */
async function restore(payload) {
    return connection_1.tryServiceDispatch(internal_1.WorkspaceAPI.RESTORE_LAYOUT, payload);
}
exports.restore = restore;
/**
 * Send this to the service when you have registered all routes after registration.
 *
 * When restoring a workspace, the service will refrain from passing the saved workspace to the application (via the
 * {@link setRestoreHandler} callback) until after the application has used this function to signal that it is ready.
 *
 * Note that by not calling this function, and workspace {@link restore} operation will hang
 * indefinitely.
 *
 * ``` ts
 * import {workspaces} from 'openfin-layouts';
 *
 * workspaces.setRestoreHandler(someRestoreFunction);
 * workspaces.setGenerateHandler(someGenerateFunction);
 * workspaces.ready();
 * ```
 *
 */
async function ready() {
    return connection_1.tryServiceDispatch(internal_1.WorkspaceAPI.APPLICATION_READY);
}
exports.ready = ready;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A simple restore handler that can be passed to {@link setRestoreHandler} when no custom logic is needed.
 *
 * This restore handler will open any child windows which are not currently running,
 * and move new and existing child windows to their expected positions for the workspace being restored.
 *
 * ``` ts
 * import {workspaces, restoreHelpers} from 'openfin-layouts';
 *
 * workspaces.setRestoreHandler(restoreHelpers.standardRestoreHandler);
 * ```
 *
 * @param workspaceApp Describes the running app's child windows and their expected post-restore state.
 * See {@link WorkspaceApp} and {@link setRestoreHandler} for more information on what this will contain.
 */
async function standardRestoreHandler(workspaceApp) {
    const errors = [];
    const openWindows = await fin.Application.getCurrentSync().getChildWindows();
    // Iterate through the child windows of the WorkspaceApp
    const opened = workspaceApp.childWindows.map(async (win) => {
        // Check if the window already exists
        if (!openWindows.some(w => w.identity.name === win.name)) {
            // Create the OpenFin window based on the data in the workspaceApp
            return createChild(win).catch((e) => {
                errors.push(e);
            });
        }
        else {
            // Only position if the window exists
            return positionChild(win).catch((e) => {
                errors.push(e);
            });
        }
    });
    // Wait for all windows to open and be positioned before returning
    await Promise.all(opened);
    if (errors.length === 0) {
        return workspaceApp;
    }
    else {
        // Consolidate any errors in restoring the children into a single error
        throw new Error('One or more errors encountered when restoring children: ' + errors.map(e => e.message).join(', '));
    }
}
exports.standardRestoreHandler = standardRestoreHandler;
/**
 * An additional helper function that can be used to create custom restore handlers.
 *
 * Given a {@link WorkspaceWindow} it will determine if the window is open and then
 * call {@link createChild} or {@link positionChild} as appropriate.
 *
 * @param workspaceWindow Object containing details of the window identity and how it should
 * be positioned/created.
 */
async function createOrPositionChild(workspaceWindow) {
    const openWindows = await fin.Application.getCurrentSync().getChildWindows();
    if (!openWindows.some(w => w.identity.name === workspaceWindow.name)) {
        // create the OpenFin window based on the data in the workspaceApp
        return createChild(workspaceWindow);
    }
    else {
        // only position if the window exists
        return positionChild(workspaceWindow);
    }
}
exports.createOrPositionChild = createOrPositionChild;
/**
 * Given a {@link WorkspaceWindow} for a non-open window, this function will create the window, position it,
 * and update its visibility, state, and frame to fit with the restoring workspace.
 *
 * Called by the {@link standardRestoreHandler} for any non-open windows in the WorkspaceApp.
 *
 * @param workspaceWindow Object containing details of the window identity and how it should
 * be created.
 *
 * @throws `Error`: If there is an existing child window with the same name.
 */
async function createChild(workspaceWindow) {
    const { bounds, frame, isShowing, name, state, url } = workspaceWindow;
    await fin.Window.create({
        url,
        autoShow: isShowing,
        defaultHeight: bounds.height,
        defaultWidth: bounds.width,
        defaultLeft: bounds.left,
        defaultTop: bounds.top,
        frame,
        state,
        name
    });
}
exports.createChild = createChild;
/**
 * Given a {@link WorkspaceWindow} object for a currently open window, this will position and
 * update the visibility, state and frame of that window to fit with the restoring
 * workspace.
 *
 * Called by the {@link standardRestoreHandler} for any currently running windows in the workspace.
 *
 * @param workspaceWindow Object containing details of the window identity and how it should
 * be positioned.
 *
 * @throws `Error`: If the window described by `workspaceWindow` is not currently running.
 */
async function positionChild(workspaceWindow) {
    const { bounds, frame, isShowing, state, isTabbed } = workspaceWindow;
    const ofWin = fin.Window.wrapSync(workspaceWindow);
    await ofWin.setBounds(bounds);
    if (isTabbed) {
        return;
    }
    if (!isShowing) {
        await ofWin.hide();
        return;
    }
    if (state === 'normal') {
        await ofWin.restore();
    }
    else if (state === 'minimized') {
        await ofWin.minimize();
    }
    else if (state === 'maximized') {
        await ofWin.maximize();
    }
    return ofWin.updateOptions({ frame });
}
exports.positionChild = positionChild;


/***/ })
/******/ ]);
});